import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_workspace } from '@/hooks/store/use_slices';
import { local_user_task_delete } from '@/state/generation/user_task/entity/local_user_task_delete';
import { LOCAL__grid2d_delete } from '@/state/grid2d/grid2d/LOCAL__grid2d_delete';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';

export function WatcherWorkspaceChildEntitySharingUserTask() {
  const dispatch = use_dispatch();

  const { user_tasks_map } = use_slice_generation(['user_tasks_map']);
  const { current_workspace_user, is_all_data_loaded, workspace_current } = use_slice_workspace([
    'current_workspace_user',
    'is_all_data_loaded',
    'workspace_current',
  ]);

  /*
   * METHODS
   */

  use_effect(() => {
    if (!is_all_data_loaded) return; //not loaded yet
    if (current_workspace_user.is_stub()) return; //no workspace selected
    if (current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW)) return; //user permitted to view collections

    let this_workspace_entities = Array.from(user_tasks_map.values()).filter(item => !item.is_shared && item.workspace_id == workspace_current._id);

    let ids_to_delete = this_workspace_entities.map(item => item._id);

    if (ids_to_delete.length > 0) {
      dispatch(LOCAL__grid2d_delete(ids_to_delete));
      dispatch(local_user_task_delete(ids_to_delete));
    }
  }, [user_tasks_map, is_all_data_loaded, current_workspace_user]);

  return <></>;
}
